import * as React from 'react'
import Page from 'src/shared/Page/Page'
import {withI18n, WithI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import autobind from 'autobind-decorator'
import FormActions from 'src/shared/form/FormActions'
import {connect} from 'react-redux'
import {RootState} from 'src/core/redux/reducer'
import {sendNewsletterInfos} from 'src/core/redux/action/newsletterAction'
import {withToast} from 'src/shared/Toast'
import {WithToast} from 'src/shared/Toast/Toast'
import {RouteComponentProps, withRouter} from 'react-router'
import { Typography, Grid, withStyles, WithStyles, Theme, createStyles } from '@material-ui/core'
import { css } from 'src/conf/style'
import Alert from 'src/shared/Alert/Alert'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'
import { fade } from '@material-ui/core/styles/colorManipulator'
import { config } from 'src/conf/config'
import { varSlugify } from 'src/shared/utils/helpers'
import PageTitle from 'src/shared/PageTitle/PageTitle'


const publications = ["Change", "Dette", "Placement", "Hebdo éco"];

const styles = (t: Theme) => createStyles({
  publication: {
    ...css.flexJcCenter,
    flexDirection: 'column',
    padding: t.spacing.unit,
    cursor: 'pointer',
    '& .media': {
      flexDirection: 'column',
      textAlign: 'center',
    }
  },
  publicationContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: t.spacing.unit,
    flex: 1,
    '&.is-selected': {
      background: fade(t.palette.primary.main, .16),
    },
    '& .media': {
      marginTop: 'auto'
    }
  },
  publicationTitle: {
    marginBottom: t.spacing.unit,
    color: t.palette.primary.main
  },
  publicationDescription: {
    margin: '0 auto',
    maxWidth: '90%',
    fontStyle: 'italic',
  },
  publicationImg: {
    display: 'block',
    width: '100% !important',
    height: 'auto !important',
    margin: '0 auto !important'
  },
  triangle: {
    margin: `${t.spacing.unit * 2}px auto`,
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '12px 25px 0 25px',
    borderColor: `${t.palette.divider} transparent transparent transparent`
  }
})

interface PublicationIProps extends WithI18n,
  WithStyles<typeof styles> {
    name: string,
    description: string,
    onChange: (name: string) => void,
    isSelected: boolean,
}


const PublicationItem = (props: PublicationIProps) => {
  const { onChange, isSelected, name, description, classes, t } = props;
  return (
    <Grid md={3} className={classes.publication} onClick={() => onChange(name)}>
      <div className={`${classes.publicationContent} ${isSelected ? 'is-selected' : ''}`}>
        <Typography variant="body2" align="center" className={classes.publicationTitle}>
          <b>{t[`Newsletter_checkbox_pme_${varSlugify(name)}`]}</b>
        </Typography>
        <Typography variant="caption" align="center" className={classes.publicationDescription}>
          {description}
        </Typography>
        <div className="media">
          <div className={classes.triangle}></div>
          <img src={config.baseUrl + `/assets/images/subscribe/abonnement_pme_${varSlugify(name)}.png`} className={classes.publicationImg}/>
        </div>
      </div>
    </Grid>
  )
}

interface IProps extends WithI18n,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>,
  WithStyles<typeof styles>,
  WithToast,
  RouteComponentProps<any> {
}

class Newsletter extends React.Component<IProps>{

  state = {
    change: false,
    dette: false,
    placement: false,
    hebdo_eco: false,
  }

  render(){
    const { t, isUpdating } = this.props;
    return (
      <>
        <HelmetMeta title={t.App_title_page_Newsletter}/>
        <PageTitle title={t.Newsletter_title} icon="chrome_reader_mode" />

        <Page width="80%">
          <Grid container>
              <Grid item xs={12}>
                <Typography variant="body2" gutterBottom>{t.Newsletter_content_first}</Typography>
                <br/>
                <Alert type="info">
                  {t.Newsletter_content_second}
                </Alert>
              </Grid>
              <Grid item xs={12}>
                <br/>
                <Grid container>
                  {publications.map(p => (
                    <PublicationItem 
                      name={p}
                      description={t[`Newsletter_publication_${varSlugify(p)}_description`]}
                      isSelected={this.state[varSlugify(p)]}
                      onChange={this.handleToggle}
                      {...this.props}
                    />
                  ))}
                  </Grid>
                  <br/>
                </Grid>
                <Grid item xs={12}>
                  <FormActions
                    loading={isUpdating}
                    disableConfirm={!this.isFormValid()}
                    confirmText={t.send}
                    confirmHandler={this.submitNews}
                  />
              </Grid>
            </Grid>
        </Page>
      </>
    )
  }

  @autobind
  private handleToggle(value: string){
    const currentState = this.state[varSlugify(value)]
    this.setState({[varSlugify(value)] : !currentState})
  }

  @autobind
  private isFormValid(){
    const { change, dette, placement, hebdo_eco  } = this.state;
    return change || dette || placement || hebdo_eco;
  }

  @autobind
  private submitNews(){
    const { t, updateInfos, toastError, toastSuccess, history, enterprise } = this.props;
    const finalArray: string[] = [];
    Object.keys(this.state).forEach(v => {
      if(this.state[v]) finalArray.push(t[`Newsletter_checkbox_pme_${v}`]);
    });
    updateInfos(finalArray)
      .then(() => {
        toastSuccess(t.Newsletter_success);
        if(enterprise && enterprise.id){
          history.push(`/ptf/enterprise/${enterprise.id}/dashboard`)
        }
      })
      .catch(err => {
        if(err.msg) toastError(err.msg)
      });
  }

}

const state2props = (state: RootState) => ({
  isUpdating: state.newsletter.isUpdating,
  enterprise: state.accountInfo.enterpriseSelected,
});

const dispatch2props = dispatch => ({
  updateInfos: (values) => dispatch(sendNewsletterInfos(values))
});

export default compose(
  withI18n,
  connect(state2props, dispatch2props),
  withToast,
  withRouter,
  withStyles(styles)
)(Newsletter);



// WEBPACK FOOTER //
// ./src/page/Consumer/Newsletter/Newsletter.tsx